import React from "react";
import { useFormContext } from "react-hook-form";
import { useReportControls } from "../hooks/ReportControlContext";
import { useReportMessage } from "../hooks/ReportMessageContext";
import { ThemedSpan } from "../../../utilities";
import { FormSelect, FormTextArea } from "../../../forms";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

export const MessageForm = ({
    isLoading = false,
    showWarning = false
} : Readonly<{
    isLoading?: boolean,
    showWarning?: boolean
}>) => {
    const { formState } = useFormContext();
    const { availableUsers } = useReportControls();
    const { message, updateMessage, updateRecipients } = useReportMessage();
    const [isWarning, setIsWarning] = React.useState<boolean>(false);

    React.useEffect(() => {
        const dirtyFields = formState.dirtyFields;
        if (dirtyFields['status'] === true) {
            setIsWarning(() => true);
        }
        else {
            setIsWarning(() => false);
        }
    }, [ formState ]);

    if (!message) {
        return null;
    }

    const { recipients, text } = message;
    return (
        <div className="row gy-2 mt-2">
            <div className="col-12">
                <FormSelect
                    label="Recipients"
                    defaultValue={recipients}
                    isDisabled={isLoading}
                    helpText={'Configure the internal system message that will be sent when the reports status is marked as "Sent".'}
                    onChange={(selected: any) => updateRecipients(selected.map((e: any) => e.value))}
                    options={availableUsers}
                    isMulti
                />
            </div>
            {(isWarning || showWarning) && (
                <div className="col-12">
                    <FontAwesomeIcon icon={faTriangleExclamation} className="text-danger mx-2" />
                    <ThemedSpan variant="primary">Warning, you are updating this report's status.</ThemedSpan>
                </div>
            )}
            <div className="col-12">
                <FormTextArea
                    disabled={isLoading}
                    placeholder="Message..."
                    value={text}
                    minRows={3}
                    maxRows={6}
                    onChange={(e: any) => updateMessage(e.target.value)}
                />
            </div>
        </div>
    );
}